<!-- Show and edit image -->
<template>
  <div v-show="image.loaded" class="card mb-3" :name="image.name">
    <img
      @load="$emit('imageLoaded')"
      class="card-img-top"
      :src="imageUrl + '/api/v1/images.get.preview/' + image.name"
      :alt="image.Title"
    />

    <div class="card-body">
      <!-- Action buttons -->
      <div class="d-flex justify-content-end buttons">
        <!-- Copy to clipboard button -->
        <button
          type="button"
          class="btn btn-outline-success me-2"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Copy to clipboard"
          @click="copyToClipboard(image.name)"
        >
          <i class="bi bi-clipboard"></i>
        </button>

        <!-- Delete button -->
        <button
          type="button"
          class="btn btn-outline-danger"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Delete image"
          @click="confirm = 'remove'"
        >
          <i class="bi bi-trash"></i>
        </button>
      </div>

      <!-- Image name -->
      <p class="card-title mt-3">{{ index + 1 }}. {{ image.name }}</p>

      <!-- Image info -->
      <div class="card-text">
        <!-- Date -->
        <div v-if="image.date">
          <small class="text-muted">Last updated: {{ image.date }}</small>
        </div>

        <!-- Styles -->
        <div v-if="image.styles">
          <small class="text-muted"
            >Styles: {{ displayStyles(image.styles) }}</small
          >
        </div>

        <!-- Prompt -->
        <div v-if="image.prompt">
          <small class="text-muted">Prompt: {{ image.prompt }}</small>
        </div>

        <!-- Tags -->
        <ImageTags
          v-if="!confirm"
          :id="image.name"
          :tags="image.tags"
        />
      </div>

      <!-- Confirm actions -->
      <ActionConfirm
        :action="actions[confirm]"
        @confirm="doDelImage(image.name)"
        @cancel="confirm = ''"
      />
    </div>
  </div>
</template>

<script>
import ImageTags from "./ImageTags.vue";
import ActionConfirm from "./ActionConfirm.vue";

const cmdDelImage = "images.del";

export default {
  name: "ImageCard",
  components: {
    ActionConfirm,
    ImageTags,
  },

  props: {
    image: Object,
    index: Number,
    imageUrl: String,

    displayStyles: Function,
  },

  data() {
    return {
      // confirm action
      confirm: "",
      actions: {
        remove: {
          name: "remove",
          text: "Remove image?",
          word: "remove",
        },
      },
    };
  },

  methods: {
    /**
     * Copies the URL of an image to the clipboard.
     * @param {string} name - The name of the image.
     */
    copyToClipboard(name) {
      // The URL of the image
      const url = this.imageUrl + "/api/v1/images.get.preview/" + name;
      // Copy the URL to the clipboard
      navigator.clipboard.writeText(url);
    },

    /**
     * Deletes an image.
     * @param {string} name - The name of the image.
     */
    doDelImage(name) {
      // Send cmdDelImage command with parameter name to WebRTC server
      this.sendCmd(cmdDelImage + "/" + name).then(
        // Process success answer
        () => {
          // Remove the image from the images array
          this.confirm = "";
          this.images = this.images.filter((item) => item.name != name);
        },
        // Process an error
        (err) => {
          console.error("cmdDelImage error:", err);
        }
      );
    },
  },
};
</script>

<style scoped>
.buttons {
  position: relative;
  margin-top: -60px;
  margin-right: -10px;
}
</style>
